module.exports = __webpack_public_path__ + "img/Autocolant TCH_150mm x 180mm-01.c625af3c.jpg";